module.exports = __webpack_public_path__ + "static/PHKitchenPT-d3d9ebd7bcb003e4a882851bfa3a5266.jpg";